import { CURRICULUMS, MODULES, StudentServicePath } from "utils/constants";
import permissions from "app/permissions";
import EditModule from "./Edit";

export const resources = {
  name: StudentServicePath + MODULES + "/" + CURRICULUMS + "/:id/edit",
  title: "Редакция модул",
  custom: <EditModule />,
  permission: permissions.canManageCurriculumModules,
};
